













import Component from 'vue-class-component';
import {Mixins, Prop} from 'vue-property-decorator';
import {CommonModelUtils, OptionElement} from '@/model/CommonModel';
import StringUtils from '@/utils/StringUtils';
import InputMixin from '@/components/input/InputMixin';

@Component({
    mixins: [InputMixin]
})
export default class RadioInput extends Mixins<InputMixin>(InputMixin) {
    @Prop({default: true}) private readonly cancelable: boolean;
    @Prop({default: true}) private readonly vertical: boolean;
    @Prop({default: () => []}) private readonly options: any[];
    
    get elementId() {
        return (index: number) => {
            return StringUtils.getId(index, this.getId);
        };
    }
    
    get elements() {
        return CommonModelUtils.getOrDefault(this.options, []);
    }
    
    get elementClass() {
        return (element: OptionElement) => {
            return {
                'is-checked': element.codeValue === this.inputValue,
                'is-disabled': this.isDisabled || this.isDisabled === '',
                'vertical': this.vertical
            };
        };
    }

    public onRadioClick(data: any) {
        if (this.isReadOnly) {
            return;
        }
    
        if (this.cancelable) {
            const radioValue = this.value === data ? '' : data;
            this.$emit('input', radioValue);
        
            if (this.changeDetectable) {
                this.$store.commit('commitValue', {
                    itemId: this.getId,
                    value: radioValue,
                    originValue: this.originValue
                });
            }
        } else {
            this.$emit('input', data);
        
            if (this.changeDetectable) {
                this.$store.commit('commitValue', {
                    itemId: this.getId,
                    value: data,
                    originValue: this.originValue
                });
            }
        }
    }
}
